import { JobsHome } from "components/jobs/JobsHome";
import { JobsSearch } from "components/jobs/JobsSearch";
import { Head } from "components/shared/layout/Head";
import { PageLayout } from "components/shared/layout/PageLayout";

import { Job, getJob } from "apis/jobs";

import { useJobSearch } from "utils/jobsSearch";

type Props = {
  job?: Job;
};
export default function Jobs({ job }: Props) {
  const { jobSearch } = useJobSearch();

  return (
    <>
      <Head pageTitle={job && job.title ? job.title : "Jobs"} />
      {job || jobSearch.jobId || jobSearch.search ? (
        <JobsSearch job={job} />
      ) : (
        <JobsHome />
      )}
    </>
  );
}

Jobs.getLayout = function getLayout(page: React.ReactNode) {
  return <PageLayout>{page}</PageLayout>;
};

export async function getServerSideProps(context: {
  query: { jobId: string };
}) {
  try {
    const job = await getJob(context.query.jobId);
    return { props: { job } };
  } catch (error) {
    return { props: {} };
  }
}
